exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1533Yrg2dC9RYb{max-height:0;opacity:.01;transition-property:opacity,max-height;transition-duration:.15s;transition-timing-function:ease-out,linear}.-IK485wPubQW8I,.USS4YIJ_gu8RJh{max-height:300px;opacity:1}.USS4YIJ_gu8RJh{transition-property:opacity,max-height;transition-duration:.2s;transition-timing-function:ease-out,linear}.tUFWdZxAMaaZe4{max-height:0;opacity:.01}", ""]);

// exports
exports.locals = {
	"revealExpandStart": "_1533Yrg2dC9RYb",
	"revealExpandEnd": "-IK485wPubQW8I",
	"fadeCollapseStart": "USS4YIJ_gu8RJh",
	"fadeCollapseEnd": "tUFWdZxAMaaZe4"
};